import { useEffect, useState } from "react";
import { getSettings, updateSettings } from "../services/api";

const Profile = () => {
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    address: "",
    facebook_url: "",
    zalo_url: "",
    tiktok_url: "",
    youtube_url: "",
    instagram_url: "",
    map_embed: "",
  });
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [logoUrl, setLogoUrl] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await getSettings();
        setFormData({
          phone: res.data.phone || "",
          email: res.data.email || "",
          address: res.data.address || "",
          facebook_url: res.data.facebook_url || "",
          zalo_url: res.data.zalo_url || "",
          tiktok_url: res.data.tiktok_url || "",
          youtube_url: res.data.youtube_url || "",
          instagram_url: res.data.instagram_url || "",
          map_embed: res.data.map_embed || "",
        });
        setLogoUrl(res.data.logo?.url || null);
        setAvatarUrl(res.data.avatar?.url || null);
      } catch (err) {
        console.error("Lỗi khi lấy cài đặt:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setStatus("loading");
      await updateSettings(formData);
      setStatus("success");
      setTimeout(() => setStatus(""), 3000);
    } catch (err) {
      console.error("Cập nhật thất bại:", err);
      setStatus("error");
    }
  };

  if (loading) return <div className="text-center mt-10">Đang tải thông tin...</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 py-10 bg-white rounded shadow">
      <h2 className="text-2xl font-bold text-center text-red-600 mb-6">
        Cấu hình thông tin website
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Avatar & Logo */}
        <div className="flex gap-4 justify-center">
          {avatarUrl && (
            <div className="text-center">
              <img src={avatarUrl} alt="Avatar" className="w-24 h-24 rounded-full object-cover" />
              <p className="text-sm mt-1">Avatar</p>
            </div>
          )}
          {logoUrl && (
            <div className="text-center">
              <img src={logoUrl} alt="Logo" className="w-24 h-24 object-contain" />
              <p className="text-sm mt-1">Logo</p>
            </div>
          )}
        </div>

        {/* Các trường thông tin */}
        <InputField label="Số điện thoại" name="phone" value={formData.phone} onChange={handleChange} required />
        <InputField label="Email" name="email" value={formData.email} onChange={handleChange} required />
        <InputField label="Địa chỉ" name="address" value={formData.address} onChange={handleChange} />

        <InputField label="Facebook URL" name="facebook_url" value={formData.facebook_url} onChange={handleChange} />
        <InputField label="Zalo URL" name="zalo_url" value={formData.zalo_url} onChange={handleChange} />
        <InputField label="TikTok URL" name="tiktok_url" value={formData.tiktok_url} onChange={handleChange} />
        <InputField label="YouTube URL" name="youtube_url" value={formData.youtube_url} onChange={handleChange} />
        <InputField label="Instagram URL" name="instagram_url" value={formData.instagram_url} onChange={handleChange} />

        <div>
          <label className="block font-semibold mb-1">Google Map Embed</label>
          <textarea
            name="map_embed"
            rows={4}
            value={formData.map_embed}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-4 py-2 resize-none"
            placeholder="<iframe ... ></iframe>"
          ></textarea>
        </div>

        <div className="pt-4">
          <button
            type="submit"
            className="w-full bg-red-600 text-white py-2 rounded font-semibold hover:bg-red-700 transition"
          >
            Lưu thay đổi
          </button>
        </div>

        {/* Trạng thái */}
        {status === "success" && (
          <p className="text-green-600 text-center font-medium">✅ Cập nhật thành công!</p>
        )}
        {status === "error" && (
          <p className="text-red-600 text-center font-medium">❌ Có lỗi xảy ra khi cập nhật.</p>
        )}
      </form>
    </div>
  );
};

export default Profile;

// Subcomponent: Reusable input field
const InputField = ({ label, name, value, onChange, required = false }) => (
  <div>
    <label className="block font-semibold mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      className="w-full border border-gray-300 rounded px-4 py-2"
      required={required}
    />
  </div>
);